module.exports = __webpack_public_path__ + "ab73662ef077b51ce49e1f890479f219.svg";